import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../api/queryKeys';
import { crudConfig } from '../conf/valueSets';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.VALUE_SETS);

export const useGetValueSets = ({ sessionToken, queryOptions = {} }) => {
    const Client = apiClient(crudConfig);
    const query = useQuery({
        queryKey: getQueryKey(),
        queryFn: () => Client.fetchAll(sessionToken),
        onSuccess: (data) => {
            // console.log('Success', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        ...queryOptions
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
